import { render, staticRenderFns } from "./ViewEmployee.vue?vue&type=template&id=2858d21e&scoped=true"
import script from "./ViewEmployee.vue?vue&type=script&lang=js"
export * from "./ViewEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858d21e",
  null
  
)

export default component.exports